export const isWeComEnv = () =>
  navigator?.userAgent?.toLowerCase()?.includes("wxwork");
